import React, { FunctionComponent } from 'react';

import { SingleFieldStepProps } from 'scenes/common/types';
import SingleYesNoStep from 'scenes/common/components/Steps/SingleYesNoStep';

const STATE_KEY = 'marketingConsent';
const QUESTION =
  'Would you like to receive special offers and information from Coles Group companies and Coles Insurance in the future?';

const MarketingConsentStep: FunctionComponent<Pick<
  SingleFieldStepProps<string>,
  'defaultStateValue' | 'onNext' | 'helpText'
>> = ({ defaultStateValue, onNext, helpText }) => (
  <SingleYesNoStep
    question={QUESTION}
    stateKey={STATE_KEY}
    defaultStateValue={defaultStateValue}
    onNext={onNext}
    helpText={helpText}
  />
);

export default MarketingConsentStep;
